const EXAMPLE_IMAGE_RE = /^https?:\/\/(www\.)?example\.com\//i;
const API_BASE = process.env.VUE_APP_BASE_URL || "/wx";
const IMAGE_PROXY_BASE = `${API_BASE}/media/image?url=`;

function normalizePathSegment(segment) {
  if (!segment) {
    return segment;
  }
  try {
    return encodeURIComponent(decodeURIComponent(segment));
  } catch (error) {
    return encodeURIComponent(segment);
  }
}

function normalizeImageUrl(url) {
  const value = String(url || "").trim();
  if (!value || /^data:image\//i.test(value)) {
    return value;
  }
  const protocolRelative = /^\/\//.test(value);
  const normalizedValue = protocolRelative ? `https:${value}` : value;
  const match = normalizedValue.match(/^(https?:\/\/[^/?#]+)?([^?#]*)(\?[^#]*)?(#.*)?$/i);
  if (!match) {
    return normalizedValue;
  }
  const [, origin = "", path = "", query = "", hash = ""] = match;
  const normalizedPath = path
    .split("/")
    .map((segment, index) => (index === 0 ? segment : normalizePathSegment(segment)))
    .join("/");
  return `${origin}${normalizedPath}${query}${hash}`;
}

function isAliOssUrl(url) {
  if (!url) {
    return false;
  }
  try {
    return /aliyuncs\.com$/i.test(new URL(String(url).trim()).hostname);
  } catch (error) {
    return false;
  }
}

export function toDisplayImageUrl(url) {
  const value = normalizeImageUrl(url);
  if (!value) {
    return "";
  }
  if (!isAliOssUrl(value)) {
    return value;
  }
  return `${IMAGE_PROXY_BASE}${encodeURIComponent(value)}`;
}

function splitImageValue(value) {
  if (!value) {
    return [];
  }
  return String(value)
    .split(",")
    .map((item) => item.trim())
    .filter(Boolean);
}

function parseExtraJson(value) {
  if (!value) {
    return null;
  }
  try {
    return typeof value === "string" ? JSON.parse(value) : value;
  } catch (error) {
    return null;
  }
}

function isUsableImage(url) {
  if (!url) {
    return false;
  }
  const value = String(url).trim();
  if (!value) {
    return false;
  }
  return !EXAMPLE_IMAGE_RE.test(value);
}

export function resolveWorkImageList(work) {
  const extra = parseExtraJson(work && work.extraJson);
  const candidates = []
    .concat(Array.isArray(work && work.imageArr) ? work.imageArr : [])
    .concat(splitImageValue(work && work.image))
    .concat(Array.isArray(extra?.work?.imageList) ? extra.work.imageList : [])
    .concat(splitImageValue(extra?.work?.images));

  return candidates.filter((item, index) => {
    if (!isUsableImage(item)) {
      return false;
    }
    return candidates.indexOf(item) === index;
  }).map((item) => toDisplayImageUrl(item));
}

export function resolveWorkCover(work, fallbackImage) {
  const imageList = resolveWorkImageList(work);
  return imageList[0] || fallbackImage;
}

export function replaceBrokenImage(event, fallbackImage) {
  if (!event || !event.target) {
    return;
  }
  const target = event.target;
  if (target.dataset && target.dataset.fallbackApplied === "1") {
    return;
  }
  if (target.dataset) {
    target.dataset.fallbackApplied = "1";
  }
  target.src = fallbackImage;
}
